export const ADD_ALERT_MESSAGE = 'ADD_ALERT_MESSAGE'
export const REMOVE_ALERT_MESSAGE = 'REMOVE_ALERT_MESSAGE'
export const SET_LOADING = 'SET_LOADING'
export const SET_BASE_STATE_VALUE = 'SET_BASE_STATE_VALUE'
